deactivateTexts = ->
    $('input#active_text').val(0)
    $('.object_in_page[data-content_type=text], .object_in_page[data-content_type=html_text]').removeClass 'active'
    # textsContainer.reload(0)
    $("#texts_container").html('')
    return


$(document).keyup (evt) ->
      if evt.which is 27
        deactivateTexts()
        textsContainer.reload(0)

        return

# $('#main_panel').click (evt) ->

#     if $(evt.target).parent().data('data-content_type') != 'text' && $('input#active_text').val() > 0
#         if !$(evt.target).parent().hasClass 'active'
#             deactivateTexts()


$(document).on 'submit', 'form.text_insert', (event) ->
    
    event.preventDefault()
    event.stopImmediatePropagation()

    # alert('insert');

    # show_menu 'texts_container'
    textsContainer.insert($('input[name=new_text]').val())



    false


$(document).on 'click', '#add_new_text',  ->
    show_menu 'texts_container'
    textsContainer.insert()
    false

$(document).on 'click', '.font_param_change',  ->
    
    $('.font_param_change[data-param='+$(@).data('param')+']').removeClass 'active'
    $(@).addClass 'active'

    $.ajax(
      dataType: 'JSON'
      method: 'POST'
      data:
        app_url: window.location.pathname
        object_id: $('input[name=text_id]').val()
        param: $(@).data('param')
        val: $(@).data('val')

      url: '/ajax/app/text_param_update/'
    ).done((data) ->
        console.log data
        loadPage()
        return
    ).fail (jqXHR, textStatus) ->
        console.warn 'Error: ' + jqXHR.responseText
        return
    return false
    return false

$(document).on 'click', '.font',  ->
    $('input[name=font]').val($(@).data('font'))
    
    data = $('form.text_update').serialize()

    $('.font').removeClass 'active'
    $(@).addClass 'active'

    $.ajax(
      dataType: 'JSON'
      method: 'POST'
      data:
        app_url: window.location.pathname
        form_data: data
      url: '/ajax/app/text_update/'
    ).done((data) ->
        console.log data
        loadPage()
        return
    ).fail (jqXHR, textStatus) ->
        console.warn 'Error: ' + jqXHR.responseText
        return
    return false

$(document).on 'click', '.color',  ->
    $('input[name=color]').val($(@).data('color'))
    
    data = $('form.text_update').serialize()

    $('.color').removeClass 'active'
    $(@).addClass 'active'

    $.ajax(
      dataType: 'JSON'
      method: 'POST'
      data:
        app_url: window.location.pathname
        form_data: data
      url: '/ajax/app/text_update/'
    ).done((data) ->
        console.log data
        loadPage()
        return
    ).fail (jqXHR, textStatus) ->
        console.warn 'Error: ' + jqXHR.responseText
        return
    return false

$(document).on 'click', '.object_in_page[data-content_type=text], .object_in_page[data-content_type=html_text]', (event) ->
   
    event.preventDefault()
    event.stopImmediatePropagation()

    console.log('text click')

    if !$(@).hasClass('active')

        $('.object_in_page[data-content_type=text]').removeClass 'active'

        $('.app_menu a').removeClass 'active'
        $('.app_menu a.texts').addClass 'active'
        $('input#active_text').val($(@).data('object_id'))

        show_menu 'texts_container'
        textsContainer.reload($(@).data('object_id'))

        console.log $(window).scrollTop()

        if $(window).scrollTop() > 400
            $('html,body').animate { scrollTop: $('#texts_container').offset().top }, 'slow'
        
        $(@).addClass 'active'
        return false

    return false
    
$(document).on 'submit', 'form.text_update', (event) ->
    
    event.preventDefault()
    event.stopImmediatePropagation()

    data = $(@).serialize()

    $.ajax(
      dataType: 'JSON'
      method: 'POST'
      data:
        app_url: window.location.pathname
        form_data: data
      url: '/ajax/app/text_update/'
    ).done((data) ->
        console.log data
        loadPage()
        return
    ).fail (jqXHR, textStatus) ->
        console.warn 'Error: ' + jqXHR.responseText
        return
    return 

    console.log data

    false
